import React from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'

import Navber from './Navber'

export default function Layout() {
	return (
		<div className="bg-neutral-300 h-screen w-screen overflow-hidden flex flex-row">
			<Sidebar />
			<div className="flex flex-col flex-1">
				<Navber />
				<div className="flex-1 p-2  min-h-0 overflow-auto">
					<Outlet />
				</div>
			</div>
		</div>
	)
}
